import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchUserGroups = createAsyncThunk("fetchUserGroups", async (keyword) => {
	const response = await axiosHttp.get(`userGroups?keyword=${keyword ?? ""}`);
	return response.data.data;
});

const UserGroupSlice = createSlice({
	name: "UserGroupSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchUserGroups.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchUserGroups.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchUserGroups.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default UserGroupSlice.reducer;
